module.exports = __webpack_public_path__ + "img/mdfg.b4cb3c69.jpg";